import { Router } from "@vaadin/router";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";

class KbTocitem extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    if (this.node) {
      this.myRender();
    }
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (this.node) {
      if (this.node?.href == this.state.selected_tocitem?.href) {
        this.node.selected = true;
        this.node.open = true;
      } else {
        this.node.selected = false;
      }
      this.myRender();
      setTimeout(
        function () {
          var tmp = this.shadowRoot.querySelector(".selected");
          if (tmp) {
            tmp.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            });
          }
        }.bind(this),
        500
      );
    }
  }

  myRender() {
    render(this.tocItemTemplate(), this.shadowRoot);
  }

  _applyFilterClass() {
    if (this.node) {
      if (this.node.hasOwnProperty("filtered")) {
        if (!this.node.filtered) {
          return "hide";
        }
      }
    }
  }

  tocItemTemplate() {
    return html`
      <style>
        #iconspan {
          display: inline-block;
          margin-left: 10px;
        }
        .selected {
          background-color: var(--kb-toc-selected);
        }
        .subitems {
          margin-left: 1.5rem;
          padding: 0.1rem;
        }
        .tocicon {
          width: 1rem;
          cursor: pointer;
        }
        .tocitemtitle {
          cursor: pointer;
        }
        .option2 {
          padding: 0.25rem 0.5rem;
          display: inline-block;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        .option1 {
          text-indent: -10px;
          padding-left: 10px;
          display: inline-block;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        .hide {
          display: none;
        }
      </style>
      <div class="${this._applyFilterClass()}">
        <span
          class="tocitemtitle  ${this.node.nodes ? "option1" : "option2"} ${this
            .node.selected
            ? "selected"
            : ""}"
          @click="${this._itemClicked.bind(this)}"
        >
          ${this.node.nodes
            ? html`<span id="iconspan">${this._icon()}</span>`
            : null}
          ${this.node.title}
        </span>
        <div class="subitems">
          ${this.node.nodes && this.node.open
            ? this.node.nodes.map(
                (node) =>
                  html`<kb-tocitem
                    .kbrid="${this.kbrid}"
                    .node="${node}"
                  ></kb-tocitem>`
              )
            : html``}
          <div></div>
        </div>
      </div>
    `;
  }

  _icon() {
    if (this.node.nodes) {
      if (this.node.open) {
        return html`<iron-icon
          class="tocicon"
          icon="vaadin:angle-down"
          @click="${this.toggleNode.bind(this)}"
        ></iron-icon>`;
      } else {
        return html`<iron-icon
          class="tocicon"
          icon="vaadin:angle-right"
          @click="${this.toggleNode.bind(this)}"
        ></iron-icon>`;
      }
    } else {
      return html`&nbsp;`;
    }
  }

  toggleNode(e) {
    e.stopPropagation();
    this.node.open = !this.node.open;
    this.myRender();
  }

  _itemClicked(e) {
    if (!this.node?.href) {
      this.toggleNode(e);
    }

    this.dispatchEvent(
      new CustomEvent("tocItemClicked", {
        bubbles: true,
        composed: true,
        detail: this.node,
      })
    );
  }
}

customElements.define("kb-tocitem", KbTocitem);
